import { configureStore } from '@reduxjs/toolkit';
import imposterReducer from './ImposterSlice';
import notificationsReducer from './NotificationsSlice';
import generalOptionsReducer from './GeneralOptionsSlice';
import personalDetailsReducer from './PersonalDetailsSlice';
import otpLoginReducer from './OTPLoginSlice';
import menuItemsReducer from './MenuItemsSlice';
import selfReferralTrackingReducer from './SelfReferralTrackingSlice';
import {
  getSelfReferralTrackingPreloadedState,
  subscribeSelfReferralTrackingPersistence,
} from './selfReferralTrackingPersistence';

export const store = configureStore({
  reducer: {
    imposter: imposterReducer,
    notifications: notificationsReducer,
    generalOptions: generalOptionsReducer,
    personalDetails: personalDetailsReducer,
    otpLoginDetails: otpLoginReducer,
    menuItems: menuItemsReducer,
    selfReferralTracking: selfReferralTrackingReducer,
  },
  preloadedState: getSelfReferralTrackingPreloadedState(),
});

subscribeSelfReferralTrackingPersistence(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
